var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"prop-jumplink-container"}},[_c('v-btn',{attrs:{"color":"secondary"},on:{"click":_vm.back}},[_vm._v(" back ")]),_vm._l((_vm.staticJumpLinks),function(ref,index){
var title = ref.title;
var url = ref.url;
return _c('v-btn',{key:(index + "--static"),attrs:{"color":"secondary","href":url}},[_vm._v(" "+_vm._s(title)+" ")])}),_vm._l((_vm.filtered),function(ref,index){
var label = ref.label;
var value = ref.value;
return _c('v-btn',{key:index,attrs:{"color":"secondary","href":value}},[_vm._v(" "+_vm._s(label)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }